import React from 'react';

export function RunInputFiles({ inputFiles }) {
  const files = Array.isArray(inputFiles) ? inputFiles : [];

  if (!files.length) {
    return <div className="mt-1 text-xs text-slate-500">Filename unavailable</div>;
  }

  return (
    <ul className="mt-1 min-w-0 space-y-0.5 text-xs text-slate-500">
      {files.map((inputFile, index) => {
        const filename = inputFile?.filename || 'Filename unavailable';
        const label = inputFile?.role
          ? `${filename} (${inputFile.role})`
          : filename;
        return (
          <li
            key={`${inputFile?.import_id ?? 'input'}-${index}`}
            className="truncate"
            title={label}
          >
            {label}
          </li>
        );
      })}
    </ul>
  );
}
